<template>
    <landing-page
    label="naviVaccination.naviVaccination"
    description="naviVaccination.naviVaccinationDesc"
    :labelColor="labelAndDescColor"
    :descColor="labelAndDescColor"
    :eggImgObj="{ componentName: 'naviVaccination', imgName: 'vaccine', imgFormat: 'svg' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconPurpleRight', imgFormat: 'svg' }"
    class="mb-10"
  />
</template>

<script setup lang="ts">
import { useVaccinationStore } from "@/stores/naviVaccination";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const vaccinationStore = useVaccinationStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};

const props = defineProps({
  labelAndDescColor: {
    type: String,
    default: "#82488F",
  }
});
</script>